import React from 'react';
import { Row } from 'react-bootstrap';
import {
  BsCalendarCheck,
  BsExclamationCircle,
  BsArrowRightShort,
  BsCalendarWeek
} from 'react-icons/bs';
import StatCard from './StatCard';
import renderUtils from '../../helpers/renderUtils';
import Percentage from '../../components/lakeview/Percentage';

const DashboardStats = ({ stats }) => (
  <Row className="mb-4">
    <StatCard
      title="Zajęte dzisiaj"
      value={stats.currentlyOccupied}
      icon={<BsCalendarCheck />}
      color="success"
    />
    <StatCard
      title="Rezerwacje nieopłacone"
      value={stats.unpaidReservations}
      count={true}
      icon={<BsExclamationCircle />}
      color="danger"
    />
    <StatCard
      title="Najbliższa rezerwacja"
      value={stats.nextReservationDate ? renderUtils.formatDate(stats.nextReservationDate) : '-'}
      icon={<BsArrowRightShort />}
      color="primary"
    />
    <StatCard
      title="Zajętość (30 dni)"
      value={<Percentage count={true} value={stats.occupancyLast30DaysPercentage} />}
      icon={<BsCalendarWeek />}
      color="warning"
    />
  </Row>
);

export default DashboardStats;
